import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientBDEFSForm() {
    return (
        <PatientFormTemplate formTitle="Your Daily Life" />
    );
}
